import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import IdentifyFrontendCode from "../../_snippets/identify-frontend-code.mdx";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The recommended way to set person properties is to send a `}<inlineCode parentName="p">{`$set`}</inlineCode>{` event with a `}<inlineCode parentName="p">{`$set`}</inlineCode>{` property. For SDKs that provide helper methods (such as `}<inlineCode parentName="p">{`posthog.setPersonProperties`}</inlineCode>{`), we recommend using them, as they handle important side effects like switching the user to identified mode.`}</p>
    <MultiLanguage selector="tabs" mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-js-web"
        }}>{`posthog.setPersonProperties(
    { name: 'Max Hedgehog' }, // $set properties
    { initial_url: '/blog' }  // $set_once properties
)
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-node"
        }}>{`client.capture({
    distinctId: 'distinct_id',
    event: '$set',
    properties: {
        $set: { name: 'Max Hedgehog'  },
        $set_once: { initial_url: '/blog' },
    },
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-python"
        }}>{`posthog.capture(
    'distinct_id',
    event='$set',
    properties={
        '$set': {'name': 'Max Hedgehog'},
        '$set_once': {'initial_url': '/blog'}
    }
)
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-php"
        }}>{`PostHog::capture(array(
    'distinctId' => 'distinct_id',
    'event' => '$set',
    'properties' => array(
        '$set' => array(
            'name' => 'Max Hedgehog'
        ),
        '$set_once' => array(
            'initial_url' => '/blog'
        )
    )
));
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-ruby"
        }}>{`posthog.capture({
    distinct_id: 'distinct_id',
    event: '$set',
    properties: {
        '$set': { name: 'Max Hedgehog' },
        '$set_once': { initial_url: '/blog' }
    }
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-go"
        }}>{`client.Enqueue(posthog.Capture{
    DistinctId: "distinct_id",
    Event:      "$set",
    Properties: map[string]interface{}{
        "$set": map[string]interface{}{
            "name": "Max Hedgehog",
        },
        "$set_once": map[string]interface{}{
            "initial_url": "/blog",
        },
    },
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-java"
        }}>{`posthog.capture("distinct_id", "$set", new HashMap<String, Object>() {
  {
    put("$set",  new HashMap<String, Object>() {       
      {
        put("name", "Max Hedgehog");
      }
    });
    put("$set_once",  new HashMap<String, Object>() {
      {
        put("initial_url", "/blog");
      }
    });
  }
});
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`curl -v -L --header "Content-Type: application/json" -d '{
    "api_key": "<ph_project_api_key>",
    "properties": {
      "$set": {"name": "Max Hedgehog" },
      "$set_once": {"initial_url": "/blog"}
    },
    "timestamp": "2020-08-16 09:03:11.913767",
    "distinct_id": "1234",
    "event": "$set"
}' <ph_client_api_host>/i/v0/e/

`}</code></pre>
    </MultiLanguage>
    <p>{`You can also set person properties when you call the `}<a parentName="p" {...{
        "href": "/docs/data/identify"
      }}><inlineCode parentName="a">{`identify`}</inlineCode></a>{` method:`}</p>

    <IdentifyFrontendCode mdxType="IdentifyFrontendCode" />
    <p>{`Person property values can be strings, booleans, numbers, objects, or arrays.  For objects and arrays, you can use `}<a parentName="p" {...{
        "href": "/docs/sql/expressions"
      }}>{`SQL expressions`}</a>{` to access nested properties in PostHog.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` Person properties are set in the order the events are ingested, and not according to event timestamps. Since we typically ingest events as soon as we receive them, you only need to take this into consideration when you're `}<a parentName="p" {...{
          "href": "/docs/migrate"
        }}>{`importing historical data`}</a>{`.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      